import { gql } from '@apollo/client';

export const EXECUTE_INVESTMENT_PAYMENT = gql`
  mutation ExecuteInvestmentPayment($investmentId: String!) {
    executeInvestmentPayment(input: { investmentId: $investmentId }) {
      success
      statusCode
      message
      error
      data {
        investmentId
        txHash
        verifiedAmount
        customerWallet
        adminId
      }
    }
  }
`;
